import React from "react"
import {useRoomParameters, useRoomSetup, useLocal} from "../AppContext"

export const ConditionsFireProtection = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const fireProtectionClass = roomParameters.getFireProtectionClasses().find(fireProtectionClass => fireProtectionClass.code === roomSetup.getFireProtectionClass())

    return local.getLabel(fireProtectionClass.name)
}
